<template>
  <div class="card">
    <div class="card-image">
      <slot name="card-image">
        <img src="https://source.unsplash.com/900x900/?snow" alt="default" />
      </slot>
    </div>
    <div class="card-title">
      <slot name="card-title">default</slot>
    </div>

    <div class="card-link">
      <slot name="card-link"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "card",
  components: {},
  data() {
    return {
      arrowHov: "inactive",
    };
  },
};
</script>

<style lang="scss">
.card {
  position: relative;
  overflow: hidden;
  min-height: 400px;

  .card-title,
  .card-image {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
  }

  .card-link {
    position: absolute;
    left: 0;
    top: 100%;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 700;
    font-size: 2rem;
    a {
      color: #fff;
      text-decoration: none;
    }
  }
  .card-title,
  .card-link {
    transform: translateY(0);
    transition: transform 0.5s ease-in-out;
  }

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  a {
    color: #fff;
    text-decoration: none;
  }

  &:hover {
    .card-title {
      transform: translateY(-100%);
    }
    .card-link {
      transform: translateY(-100%);
    }

    .card-image {
      img {
        filter: blur(5px);
        filter: brightness(0.5);
      }
    }
  }
  .card-image {
    //   overflow:hidden;
    &::after {
      content: "";
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;

      background-color: rgba(0, 0, 0, 0.2);
    }
    img {
      filter: blur(0px);
      filter: brightness(1);
      transition: filter 0.5s ease-in-out;
    }
  }
  .card-title {
    display: flex;
    justify-content: center;
    align-items: center;
    color: #fff;
    font-weight: 700;
    font-size: 3rem;
    cursor: pointer;
  }
}
</style>
